import styled from 'styled-components'
import { colors } from 'constants/colors';

export const CardContainer = styled.div<{ selected?: boolean, padding?: string, pointer?: boolean }>`
  width: 100%;
  padding: ${({ padding }) => padding? padding:'16px'};
  box-shadow: ${({ selected }) => selected? `0 1px 3px ${colors.accounMenuBorderShadowColor}`: `0 1px 3px ${colors.cardShadow}`};
  margin-bottom: 24px;

  ${({ selected }) => selected? `border: 1px solid ${colors.optionBackground};` : `border: 1px solid ${colors.signInBorderColor};`}
  ${({ pointer }) => pointer? 'cursor: pointer' : null}
`;